import authorityApi from '../../../api/authority';
import types from './mutations-types';

export default {
  namespaced: true,
  state: {
    // 用户信息列表
    userList: [],
    // 角色信息列表
    roleList: [],
    // 设备信息列表
    deviceList: [],
    // 项目信息列表
    projectList: [],
  },
  mutations: {
    // 获取用户信息
    [types.GET_USER_LIST](state) {
      state.userList = [];
      authorityApi.getUserList().then((res) => {
        res.map((item) => {
          state.userList.push(item);
        });
      });
    },
    // 获取角色信息
    [types.GET_ROLE_LIST](state) {
      state.roleList = [];
      authorityApi.getRoleList().then((res) => {
        res.map((item) => {
          state.roleList.push(item);
        });
      });
    },
    // 获取设备信息
    [types.GET_DEVICE_LIST](state) {
      state.deviceList = [];
      authorityApi.getDeviceList().then((res) => {
        res.map((item) => {
          state.deviceList.push(item);
        });
      });
    },
    // 获取项目信息
    [types.GET_PROJECT_LIST](state) {
      state.projectList = [];
      authorityApi.getProjectList().then((res) => {
        res.map((item) => {
          state.projectList.push(item);
        });
      });
    },
  },
  actions: {
    getUserList({ commit }) {
      commit(types.GET_USER_LIST);
    },
    getRoleList({ commit }) {
      commit(types.GET_ROLE_LIST);
    },
    getDeviceList({ commit }) {
      commit(types.GET_DEVICE_LIST);
    },
    getProjectList({ commit }) {
      commit(types.GET_PROJECT_LIST);
    },
  },
  getters: {
    // 部门信息列表（去重）
    deptList(state) {
      const deptList = [];
      for (let i = 0; i < state.userList.length; i++) {
        if (deptList.indexOf(state.userList[i].deptName) === -1) {
          deptList.push(state.userList[i].deptName);
        }
      }
      return deptList;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/authority/index.js